import { assertNever } from './assertNever'

// Bounds the edge-strip regex, which backtracks quadratically on long non-alphanumeric runs.
export const MAX_ORGANISATION_ID_LENGTH = 64

const EDGE_NON_ALPHANUMERIC = /^[^0-9a-zA-Z]+|[^0-9a-zA-Z]+$/g

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/

export type OrganisationResolution =
  | { status: 'configured'; organisationId: string; received: string }
  | { status: 'unconfigured'; organisationId: string; received: string }
  | { status: 'missing'; organisationId: string; received: null }
  | { status: 'malformed'; organisationId: null; received: string }

export const normaliseOrganisationId = (
  raw: string | null | undefined,
): string => {
  if (raw == null || raw.length > MAX_ORGANISATION_ID_LENGTH) {
    return ''
  }
  return raw.replace(EDGE_NON_ALPHANUMERIC, '').toLowerCase()
}

export const isValidOrganisationId = (normalised: string): boolean =>
  UUID.test(normalised)

const echo = (received: string) => received.slice(0, MAX_ORGANISATION_ID_LENGTH)

const warningFor = (resolution: OrganisationResolution): string | null => {
  switch (resolution.status) {
    case 'missing':
      return `[finprom] organisationId missing from URL; falling back to manual-testing organisation "${resolution.organisationId}"`
    case 'unconfigured':
      return `[finprom] organisationId "${echo(resolution.received)}" is not a configured organisation; using default branding`
    case 'malformed':
      return `[finprom] organisationId "${echo(resolution.received)}" is not a valid organisation id; showing invalid-link error`
    case 'configured':
      return null
    default:
      return assertNever(resolution, null)
  }
}

export const warnOnOrganisationResolution = (
  resolution: OrganisationResolution,
): void => {
  const message = warningFor(resolution)
  if (message) {
    console.warn(message)
  }
}
